module.exports = __webpack_public_path__ + "img/ep-S.238f2530.jpg";